import { ageMs, relativeFromNow } from '../../util/time';

// The controller publishes every ~30 s control cycle (+ a 60 s heartbeat).
// Match the cloud heartbeat-watchdog's 5-minute window: past that, treat
// the device as offline and warn that the dashboard's values are the last
// reported snapshot (link_health, readings, etc. are all frozen because
// twin.reported only updates while the controller is online). This is the
// controller↔cloud gap; ConnectionBanner covers the separate app↔cloud one.
const OFFLINE_THRESHOLD_MS = 5 * 60 * 1000;

export function DeviceOfflineBanner({ lastReportedAt }: { lastReportedAt?: string | undefined }) {
  if (!lastReportedAt) return null;
  if (ageMs(lastReportedAt) <= OFFLINE_THRESHOLD_MS) return null;
  return (
    <div className="banner danger" role="alert">
      <strong>Controller offline.</strong> Last update {relativeFromNow(lastReportedAt)} — the
      values below are the last reported and may be out of date.
    </div>
  );
}
